import { IconX } from "@tabler/icons-react";
import { useState } from "react";
import { updateBankStatementIdDonation } from "../../../Api/Donation";

interface DonationModelProps {
  isOpen: boolean;
  onClose: () => void;
  transactionAmount: number;
  bankstatementId: string;
  Donations: any[];
  fetchDonationData: (id: string, amount: number) => Promise<void>;
  fetchAssignedDonationData: (id: string) => Promise<void>;
  onSuccess?: () => void;
}

const DonationModel = ({
  isOpen,
  onClose,
  transactionAmount,
  bankstatementId,
  Donations,
  fetchDonationData,
  fetchAssignedDonationData,
  onSuccess,
}: DonationModelProps) => {
  const [selectedDonationKeys, setSelectedDonationKeys] = useState<number[]>(
    []
  );

  const handleCheckboxChange = (uniqueKey: number) => {
    setSelectedDonationKeys((prevSelected) =>
      prevSelected.includes(uniqueKey)
        ? prevSelected.filter((key) => key !== uniqueKey)
        : [...prevSelected, uniqueKey]
    );
  };

  const selectedDonationAmount = Donations.reduce((total, donation) => {
    return selectedDonationKeys.includes(donation.referenceId)
      ? total + donation.amount
      : total;
  }, 0);

  const isSubmitEnabled = selectedDonationAmount === transactionAmount;

  const handleSubmit = async () => {
    try {
      await updateBankStatementIdDonation(
        selectedDonationKeys,
        bankstatementId
      );
      await fetchDonationData(bankstatementId,transactionAmount);
      await fetchAssignedDonationData(bankstatementId);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error updating bank statement ID:", error);
    }
  };

  return (
    <div className="p-6">
      <div>
        <div className="flex justify-between items-center border-b pb-1">
          <h1 className="flex justify-center text-xl font-semibold text-blue-700">
            Assign Donation
          </h1>
        </div>

        <div
          className="mt-4 overflow-auto"
          style={{
            maxHeight: "80vh",
          }}
        >
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reference ID
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  UserName
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                 Email
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                 Mobile No
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Donated On
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Donations.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="px-1 py-4 text-sm text-gray-900 text-center"
                  >
                    No donations found.
                  </td>
                </tr>
              ) : (
                Donations.map((donation) => {
                  return (
                    <tr key={donation.id}>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        <input
                          type="checkbox"
                          name="donation"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
                          checked={selectedDonationKeys.includes(
                            donation.referenceId
                          )}
                          onChange={() =>
                            handleCheckboxChange(donation.referenceId)
                          }
                        />
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {donation.referenceId}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {donation.userName
}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {donation.mobile}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {donation.email}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {donation.amount}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(donation.donatedOn).toLocaleDateString(
                          "hi-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-2">
          <p className="flex justify-center text-sm text-gray-700">
            Selected donation amount: {selectedDonationAmount} /{" "}
            {transactionAmount}
          </p>
        </div>

        <div className="flex justify-start mt-4">
          <button
            className={`bg-blue-500 text-white px-3 py-2 rounded-md mr-2 text-sm ${
              isSubmitEnabled
                ? "hover:bg-blue-600"
                : "opacity-50 cursor-not-allowed"
            }`}
            disabled={!isSubmitEnabled}
            onClick={() => {
              handleSubmit();
              onClose();
            }}
          >
            Submit
          </button>
          <button
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600 mr-2 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonationModel;
